import React from "react";
interface props {
  className?: string;
  width?: any;
  height?: any;
}

function CheckIcon({ className, width, height }: props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width || "24"}
      height={height || "24"}
      fill="none"
      viewBox="0 0 24 24"
    >
      <g clipPath="url(#clip0_830_13004)">
        <path
          stroke="#4DBB3E"
          strokeWidth="1.6"
          d="M6.397 12l4.8 4 6.4-8m-5.6 15.2a11.2 11.2 0 110-22.398 11.2 11.2 0 010 22.399z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_830_13004">
          <path fill="#fff" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default CheckIcon;
